<ifc-app-card-one-column>
  <mat-card appearance="outlined" class="card">
    <mat-card-header class="card-header">
      <mat-card-title>Transfer details</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-lg no-bottom-padding">
      <ifc-horizontal-list [items]="items"></ifc-horizontal-list>
    </mat-card-content>
  </mat-card>
</ifc-app-card-one-column>
